// activeCalibrationLogBook/activeCalibrationLogBookState.js

import { calibrationLogBookFormInitialState } from "../forms/calibrationLogBookForm/calibrationLogBookFormState";

export const activeCalibrationLogBookInitialState = {
  isLoading: false,
  error: null,
  currentBook: null, // Full CalibrationLogBook class instance
  _rev: 0, // Revision counter for change detection with mutable updates
  calibrationLogBookForm: calibrationLogBookFormInitialState,
};
